<template>
  <div :class="{'flex-wrap table-filter-item': label}">
    <div v-if="label" class="flex-align-center table-filter-label">{{ label }}：</div>
    <el-select
      v-model="valueBackup"
      @change="handleChange"
      :multiple="multiple"
      :clearable="clearable"
      :size="size"
      :placeholder="placeholder"
      :style="width ? `width: ${width}` : ''"
    >
      <el-option
        v-for="item in list"
        :key="item.id"
        :label="item.card_type_name"
        :value="item.id"
      />
    </el-select>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { index } from '@/api/card-type';

export default {
  props: {
    value: {
      type: [String, Number, Array],
      default: '',
    },
    width: {
      type: String,
      default: '',
    },
    storeId: {
      type: [String, Number],
      default: '',
    },
    multiple: Boolean,
    clearable: Boolean,
    label: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'medium',
    },
    placeholder: {
      type: String,
      default: '请选择课程类型',
    },
  },
  data: () => ({
    valueBackup: '',
    list: [],
  }),
  watch: {
    value(value) {
      if (this.multiple) {
        if (JSON.stringify(value) !== JSON.stringify(this.valueBackup)) this.valueBackup = value || [];
      } else {
        if (value !== this.valueBackup) this.valueBackup = +value || '';
      }
    },
    valueBackup(valueBackup) {
      if (this.multiple) {
        if (JSON.stringify(valueBackup) !== JSON.stringify(this.value)) this.$emit('input', valueBackup);
      } else {
        if (valueBackup !== (+this.value || '')) this.$emit('input', valueBackup);
      }
    },
    storeId(storeId) {
      if (storeId) this.getList(storeId);
    },
  },
  computed: {
    ...mapGetters([
      'isAdministrator',
      'isGenericStore',
    ]),
  },
  methods: {
    async getList(store_id) {
      const { isError, data } = await index({ store_id });
      if (!isError) this.list = data;
    },
    handleChange(valueBackup) {
      this.$emit('change', valueBackup);
    },
  },
  beforeMount() {
    if (this.multiple) {
      this.valueBackup = this.value || [];
    } else {
      this.valueBackup = +this.value || '';
    }
    this.getList(this.storeId);
  },
};
</script>
